import Config from '../../../config/Config'
import { map, mergeMap, catchError, withLatestFrom } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { jwtSelector } from '../../auth/selectors'
import * as actions from '../actions'
import { rootCatchError } from '../../../lib/Utils'

const ValidAdTypes = [
  'DESKTOP_FEED_STANDARD',
  'MOBILE_FEED_STANDARD',
  'INSTAGRAM_STANDARD',
  'MOBILE_INTERSTITIAL',
  'FACEBOOK_STORY_MOBILE',
  'INSTAGRAM_STORY',
  'MESSENGER_MOBILE_STORY_MEDIA',
]

export const postAdCreativeTemplatePreviewObservable = ([action, state]) => {
  const {
    adcreative_template_id,
    retailerId,
    facebookPageId,
    adType,
  } = action.payload

  const jwt = jwtSelector(state) || action.payload.jwt

  if (!jwt) {
    throw new Error('Non-existent JWT auth')
  }

  if (!adcreative_template_id) {
    throw new Error('Ad creative template ID required')
  }

  if (!retailerId) {
    throw new Error('Retailer ID required')
  }

  if (!facebookPageId) {
    throw new Error('Facebook Page ID required')
  }

  if (!adType || ValidAdTypes.indexOf(adType) === -1) {
    throw new Error(`Valid ad type required: ${ValidAdTypes.join(',')}`)
  }

  let paramsList = []
  if (retailerId) {
    paramsList.push(`retailer_id=${retailerId}`)
  }
  if (facebookPageId) {
    paramsList.push(`facebook_page_id=${facebookPageId}`)
  }
  if (adType) {
    paramsList.push(`ad_format=${adType}`)
  }

  const settings = {
    method: 'POST',
    responseType: 'json',
    headers: {
      Authorization: jwt,
    },
    body: JSON.stringify(action.payload),
    url: `${
      Config.SERVICE_BASE
    }/facebookad/v1/adcreative_template/${adcreative_template_id}/preview?${paramsList.join(
      '&',
    )}`,
  }

  return ajax(settings).pipe(
    map((payload) => {
      return {
        type: actions.POST_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED,
        payload: {
          iframe: payload.response[0].body,
          adcreative_template_id,
        },
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.POST_AD_CREATIVE_TEMPLATE_PREVIEW_REJECTED,
        payload: payload.response,
      })
    }),
  )
}

export const postAdCreativeTemplatePreviewEpic = (action$, state$) => {
  return action$.pipe(
    ofType(actions.POST_AD_CREATIVE_TEMPLATE_PREVIEW),
    withLatestFrom(state$),
    mergeMap(postAdCreativeTemplatePreviewObservable),
    rootCatchError(actions.POST_AD_CREATIVE_TEMPLATE_PREVIEW_REJECTED),
  )
}
